export default __webpack_public_path__ + "static/media/fail-sync-big.5608275c.svg";